module.exports = __webpack_public_path__ + "img/2.02.thmb.xs.397b1430.jpg";